import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useEffect, useMemo, useLayoutEffect, useState } from 'react';
import { useInViewport } from '../hooks';
import { useLatest } from '../hooks';

var Lazyload = function Lazyload(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      style = _ref.style,
      dynamic = _ref.dynamic,
      offset = _ref.offset,
      height = _ref.height;
  var onChangeRef = useLatest(onChange);
  var ref = useRef(null);
  var clientHeightRef = useRef();
  var options = useMemo(function () {
    return {
      rootMargin: offset + "px"
    };
  }, [offset]);

  var _useInViewport = useInViewport(ref, options),
      inViewPort = _useInViewport[0];

  var _useState = useState(false),
      inited = _useState[0],
      setInited = _useState[1];

  useLayoutEffect(function () {
    var _a;

    if (inViewPort) {
      setInited(true);
    }

    if (inViewPort && dynamic) {
      clientHeightRef.current = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
    }
  }, [inViewPort, dynamic]);
  var styles = useMemo(function () {
    if (dynamic) {
      if (inited) {
        return Object.assign(Object.assign({}, style), {
          height: inViewPort ? undefined : clientHeightRef.current
        });
      }

      return Object.assign(Object.assign({}, style), {
        height: height
      });
    }

    return style;
  }, [style, height, dynamic, inViewPort, inited]);
  useEffect(function () {
    var _a;

    (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, inViewPort);
  }, [inViewPort]);
  return _jsx("div", Object.assign({
    ref: ref,
    className: "by-lego-lazyload",
    style: styles
  }, {
    children: dynamic ? inViewPort && children : children
  }));
};

Lazyload.displayName = 'Lazyload';
Lazyload.defaultProps = {
  dynamic: false,
  offset: 0
};
export default Lazyload;